module.exports = __webpack_public_path__ + "static/img/pacs.a87ef97e.png";